export default {
    fields: [
        {
            type: "text",
            label: "First Name*",
            queryParam: "firstName",
            rules: [
                v => (!!v && v.length >= 1) || "Should be atleast 1 characters"
            ],
            value: "",
            updatable: true
        },
        {
            type: "text",
            label: "Last Name*",
            queryParam: "lastName",
            rules: [
                v => !!v || "This field is mandatory",
                v => !v || v.length >= 1 || "Should be atleast 1 characters"
            ],
            value: "",
            updatable: true
        },
        {
            type: "text",
            label: "Email*",
            queryParam: "email",
            rules: [v => /.+@.+\..+/.test(v) || "Email must be valid"],
            value: "",
            hint: "Password will be sent to this email. Ensure its real.",
            updatable: true
        },
        {
            type: "text",
            label: "Username*",
            queryParam: "userName",
            rules: [
                v => (!!v && v.length >= 5) || "Should be atleast 5 characters"
            ],
            value: "",
            updatable: false
        },        
        {
            type: "dropdown",
            model: "roles",
            label: "Role Name*",
            queryParam: "roleId",
            rules: [v => v !== undefined || "This field is mandatory"],
            updatable: true
        },
        {
            type: "dropdown",
            label: "Status*",
            queryParam: "active",
            rules: [v => v !== undefined || "This field is mandatory"],
            items: [
                { text: "Enabled", value: true },
                { text: "Disabled", value: false }
            ],
            value: true,
            updatable: true
        },
        {
            type: "textarea",
            label: "Notes",
            queryParam: "notes",
            updatable: true
        }
    ],
}